import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons/";

const ToolBarFilterButton = (props) => {
  const {
    id,
    currentOption,
    filterButtonsOpen,
    className,
    style,
    text,
    onClick,
    filter,
    ...restProps
  } = props;
  return (
    <button
      onClick={() => {
        onClick(filter);
      }}
      id={id}
      style={{ paddingBottom: 0, ...style }}
      className={`${
        className ? className : ""
      } focus:tw-outline-none tw-ml-2 hover:tw-outline-none hover:tw-bg-none hover:cursor-pointer tw-border-0 tw-bg-white tw-flex tw-items-start`}
      {...restProps}
    >
      <strong>{text}</strong>
      <FontAwesomeIcon
        className={`${
          currentOption === filter && filterButtonsOpen && "tw-rotate-180"
        } tw-transform tw-transition tw-ml-1 tw-text-3xl tw-mt-auto`}
        style={{ height: 20 }}
        icon={faCaretDown}
      />
    </button>
  );
};

export default ToolBarFilterButton;
